import { useMemo } from "react";

import { TierPackageTypes } from "@doitintl/cmp-models";

import { useTier } from "../Context/TierProvider";

export const useIsNavigatorEssentials = (): boolean => {
  const { getCustomerTier } = useTier();
  const navigatorTier = getCustomerTier(TierPackageTypes.NAVIGATOR);

  return useMemo(() => navigatorTier?.name === "essentials", [navigatorTier]);
};
